import React, { Component } from 'react';
import Search from '../Search';
import Scan from '../Scan';
import styles from './styles.scss';
import request from '../../request';
import * as print from 'print';
import * as Helper from '../../utils/helper';
import { captureEvent } from '../../utils/sentryHelper';

export default class PrintDSWmsBarcode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: 'search',
            data: {},
            partner_type: 'secondary',
        };
    }

    printLabel = items => {
        const labels = items.map(product => {
            const qty = product.qty || 1;
            const label = `${product.title_en}`.trim();
            const data = { ...product, qty, label };
            return print.generateLabel(data);
        });

        print.print(labels);
    };

    async componentDidMount() {
        this.getData();
    }

    getPartnerType = () => {
        this.setState({
            partner_type: "primary"
        }, () => this.getData())
    }

    getData = async () => {
        const awb = this.props.match.params.awb;
        const { partner_type } = this.state;

        request
        // TODO change API URL to dark store new API
            .get(`/_svc/darkstore-api-inbound/misc/print/${awb}/lines?partner_type=${partner_type}`, null, {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
              },
            })
            .then(response => this.setState({ data: response }))
            .catch(error =>
                captureEvent((error && error.message) || error, {
                    logger: 'PrintDSWmsBarcode.componentDidMount',
                    extra: error,
                    level: Helper.getSentryErrorLevel(error.code),
                }),
            );
    }

    render() {
        const { data } = this.state;
        return (
            <div className={styles.homeScreen}>
                <div className={styles.viewSwitcher}>
                    <button
                        className={
                            this.state.view === 'search' ? styles.active : {}
                        }
                        onClick={() => this.setState({ view: 'search' })}
                    >
                        <i className="icon-search" />
                        Search
                    </button>
                    <button
                        className={
                            this.state.view === 'scan' ? styles.active : {}
                        }
                        onClick={() => this.setState({ view: 'scan' })}
                    >
                        <i className="icon-barcode" />
                        Scan
                    </button>

                    <button className={
                            this.state.partner_type === 'primary' ? styles.active : {}
                        } onClick={() => this.getPartnerType()}
                    >
                        ALL PRODUCTS
                    </button>

                </div>
                {this.state.view === 'search' ? (
                    <Search printLabel={this.printLabel} data={data} />
                ) : (
                    <Scan printLabel={this.printLabel} data={data} />
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PrintDSWmsBarcode/index.js